import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Typography,
  Box,
} from "@material-ui/core";
import { TagsContainer } from "../TagsContainer";
import TagModal from "../TagModal";
import { dialogSurface } from "../../theme/redesign";

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      ...dialogSurface(theme),
      minWidth: "500px",
      maxWidth: "640px",
    },
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: theme.palette.primary.main,
    padding: theme.spacing(2, 3, 1, 3),
  },
  content: {
    padding: theme.spacing(2, 3),
  },
  actions: {
    padding: theme.spacing(2, 3),
    gap: theme.spacing(1),
  },
  ticketInfo: {
    backgroundColor: theme.palette.grey[50],
    padding: theme.spacing(2),
    borderRadius: "8px",
    marginBottom: theme.spacing(2),
  },
  ticketTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
  },
  ticketDetails: {
    fontSize: "0.875rem",
    color: theme.palette.text.secondary,
  },
}));

const TagsModal = ({ open, onClose, ticketId, ticket }) => {
  const classes = useStyles();
  const [createTagOpen, setCreateTagOpen] = useState(false);

  if (!ticket && !ticketId) return null;

  return (
    <>
      <Dialog
        open={open && !createTagOpen}
        onClose={onClose}
        className={classes.dialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.title}>
          Etiquetas del ticket
        </DialogTitle>
        <DialogContent className={classes.content}>
          {ticket && (
            <Box className={classes.ticketInfo}>
              <Typography className={classes.ticketTitle}>
                Ticket #{ticket.id}
              </Typography>
              <Typography className={classes.ticketDetails}>
                Contacto: {ticket.contact?.name || "Sin contacto"}
              </Typography>
            </Box>
          )}
          <Typography variant="body2" paragraph>
            Selecciona o quita etiquetas de este ticket. También puedes escribir un nombre nuevo para crearla y asignarla.
          </Typography>
          {ticket && <TagsContainer ticket={ticket} />}
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={onClose} variant="outlined" color="secondary">
            Cerrar
          </Button>
          <Button
            onClick={() => setCreateTagOpen(true)}
            variant="contained"
            color="primary"
          >
            Nueva etiqueta del catálogo
          </Button>
        </DialogActions>
      </Dialog>
      <TagModal
        open={createTagOpen}
        onClose={() => setCreateTagOpen(false)}
        tagId={null}
      />
    </>
  );
};

export default TagsModal;
